import React, { Component } from "react";
import { FormGroup, Col, Label, Button } from "reactstrap";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import {
  saveExportWithoutSchedule,
  updateExportWithoutSchedule,
} from "../../../../action/ReportManagement/ManageReports";
import {saveReportSchedule} from '../../../../action/ReportManagement/ScheduleReport';
import { setAmplitudeEvent } from 'amplitude/amplitude';

class Archive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      IsFromReportSchedules: false,
      isEmailOnlyRadioActive:false,
      isEmailRadioActive:false,
      redirectToListPage: false,
      IsNoArchive: true,
      IsArchive:false,
      reportName: "",
      description: "",
      reportDesc: "",
      reportPeriod: "0D",
      customStartDate: new Date(),
      customEndDate: new Date(),
      datalogIds: [],
      reportId: 0,
      SelectedReportDetails: "",
      emailReceipentDetails: "",
      exportRecurrenceList:"",
      reportNameValue:''
    };
    this.goBack = this.goBack.bind(this);
    this.OnFinish = this.OnFinish.bind(this);
    this.OnCancel = this.OnCancel.bind(this);
    this.handleRadio = this.handleRadio.bind(this);
    this.SetDataToEdit = this.SetDataToEdit.bind(this);
    this.disableRadioBtn = this.disableRadioBtn.bind(this)
    this.notEditDisable = this.notEditDisable.bind(this);
  }

  componentWillMount() {
    var IsFromReportSchedules;

    IsFromReportSchedules = sessionStorage.getItem("IsFromReportSchedules");
    if (
      IsFromReportSchedules !== undefined &&
      IsFromReportSchedules !== null &&
      IsFromReportSchedules === "true"
    ) {
      this.setState({ IsFromReportSchedules: true });
    }

    var SelectedReportDetails;
    SelectedReportDetails = sessionStorage.getItem("SelectedReportDetails");
    if (SelectedReportDetails !== undefined && SelectedReportDetails !== null) {
      var details = JSON.parse(SelectedReportDetails);
      this.setState({
        SelectedReportDetails: JSON.parse(SelectedReportDetails), reportNameValue: details.name
      });
      this.setState({ reportId: details.id });
    }
  }

  componentWillReceiveProps(nextProps) {

    if(this.props.isEmailandArchive !== nextProps.isEmailandArchive){
      //passing the individual props to function disableRadiobtn
       this.disableRadioBtn(nextProps.isEmailandArchive)
    }

    if (this.props !== nextProps) {
      this.setState({
        reportName: nextProps.ReportName,
        reportPeriod: nextProps.ReportPeriod,
        customStartDate: nextProps.CustomStartDate,
        customEndDate: nextProps.CustomEndDate,
        datalogIds: nextProps.DatalogDefinitionIds,
        description: nextProps.Description,
        emailReceipentDetails: nextProps.EmailReceipentDetails,
      });

    }

    
  }



  //This function will be used to disableRadio buttons based on if it is edited or not 
  disableRadioBtn(radioSelected){
    var isSelected = radioSelected;
    var SelectedReportDetails;
    SelectedReportDetails = sessionStorage.getItem("SelectedReportDetails");
    let hasFullaccess = this.props.userHasFullaccess;
    hasFullaccess = hasFullaccess !== undefined && hasFullaccess !== null && hasFullaccess ? true: false;
    if (SelectedReportDetails !== undefined && SelectedReportDetails !== null) {
      var details = JSON.parse(SelectedReportDetails);
      if (details.isScheduled === false) {
        this.SetDataToEdit(details.isScheduled,radioSelected)
      }else{
        this.SetDataToEdit(details.maintainFilesOnServer,radioSelected)
      }
    }else{
      this.notEditDisable(isSelected,hasFullaccess)
    }
  }

    //changing this not only look at data but also 
  SetDataToEdit(maintainFilesOnServer,radioSelected) {
    if (maintainFilesOnServer !== undefined && maintainFilesOnServer !== null) {
      if (maintainFilesOnServer === true) {
        if (radioSelected === "All") { 
          this.setState({
            isEmailOnlyRadioActive: false,
            isEmailRadioActive: false,
            IsArchive:maintainFilesOnServer,
            IsNoArchive:!maintainFilesOnServer 
          });
        }else{
          this.setState({
            isEmailOnlyRadioActive: true,
            isEmailRadioActive: false,
            IsArchive:maintainFilesOnServer,
            IsNoArchive:!maintainFilesOnServer
          })
        }
      } else {
        if (radioSelected === "All") { 
          this.setState({
            isEmailOnlyRadioActive: false,
            isEmailRadioActive: false,
            IsArchive:false,
            IsNoArchive:true 
          });
        }else{
          this.setState({
            isEmailOnlyRadioActive: true,
            isEmailRadioActive: false,
            IsArchive:true,
            IsNoArchive:false
          })
        }
      }
    }
  }

  //this function will be used for new report creation to determine if radiobutton should be disabled
  notEditDisable(isSelected,hasFullaccess){
    switch (isSelected) {
      case "Archive":
        if (hasFullaccess === true) {
          this.setState({
            isEmailOnlyRadioActive: true,
            isEmailRadioActive: false,
            IsArchive:true,
            IsNoArchive:false
          })
        } else {
          this.setState({
            isEmailOnlyRadioActive: true,
            isEmailRadioActive: true,
            IsArchive:true,
            IsNoArchive:false
          })
        }
      break;
      case "All":
        if (hasFullaccess === true) {
          this.setState({
            isEmailOnlyRadioActive: false,
            isEmailRadioActive: false,
            IsArchive:false,
            IsNoArchive:true         
           })
        } else {
          this.setState({
            isEmailOnlyRadioActive: true,
            isEmailRadioActive: true,
            IsArchive:false,
            IsNoArchive:true
          })
        }
      break;
      default:
      break;
    }

  }

  OnCancel() {
    this.setState({ redirectToListPage: true });
  }

  goBack(tab) {
    this.props.toggle(tab);
  }

  OnFinish() {
    var dataExportDetails = {
      "ReportId": this.state.reportId,
      "ReportName": this.state.reportName,
      "Description": this.state.description,
      "ReportPeriod": this.state.reportPeriod,
      "CustomStartDateTime": this.state.customStartDate,
      "CustomEndDateTime": this.state.customEndDate,
      "DatalogDefinitionIds": this.state.datalogIds,
      "MaintainOnServer": this.state.IsNoArchive ? 0 : 1,
    };

    var dataExportFinalData = {
      "DataExportDefinition": dataExportDetails,
      "RecipientEmail": this.state.emailReceipentDetails,
      "ReportScheduleParams" : this.props.RecurrenceDetails.ExportRecurrenceList,
      "CalendarEntry" : this.props.RecurrenceDetails.calendarEntries,
      "DeletionEntry" : this.props.RecurrenceDetails.deletedReportScheduleId,
      "MaintainOnServer": this.state.IsNoArchive ? 0 : 1
    };

    //Amplitude
    // ReportType
    var l_ReportType = this.props.RecurrenceDetails.ReportType !== undefined || this.props.RecurrenceDetails.ReportType !== null ? this.props.RecurrenceDetails.ReportType : 0;   


    var l_Archieve = this.state.IsNoArchive ? "Email Report Only" : "Email Report and Save to Report History";
    var reportType = (l_ReportType !== 0) ? (l_ReportType === -1) ? "Custom Report" : (l_ReportType === 99) ? "Data Export" : "Standard Report" : ""

    //add this if to check if the report is being changed 
    //because a user clicked on the scheduled button in the dropdown.
    if (this.state.IsFromReportSchedules === false) { // From Data Export
      // Amplitude - Report Schedule 
      var l_Actions = this.state.reportId === 0 ? "Create Data Export Wizard" : "Edit Data Export Wizard";
      if (this.state.reportId !== 0) { // Edit Data Export
        const l_Request = this.props.updateExportWithoutSchedule(dataExportFinalData);

        l_Request.then((result) => {
          var index = 0;
          for (index = 0; index < this.props.RecurrenceDetails.AmplitudeRecurrenceList.length; index++) { 
            setAmplitudeEvent("Report Schedule",{"Report Type": "Data Export" , "User Flow" : l_Actions, "Schedule Recurrence" :  this.props.RecurrenceDetails.AmplitudeRecurrenceList[index].intervalType, "File Format" :  this.props.RecurrenceDetails.AmplitudeRecurrenceList[index].exportFormat,  
            "Report History Save Option" : l_Archieve});
          }

          this.setState({ redirectToListPage: true });
        });
      } else { // Create Data Export
       
        //Amplitude - Data Export 
        switch(this.state.reportPeriod){
          case "-1D" : 
          setAmplitudeEvent("Create Data Export Report",{" Standard Time Period": "Yesterday" , "Export History Save Option" : l_Archieve});
          break;
          case "1W" :
          setAmplitudeEvent("Create Data Export Report",{" Standard Time Period": "This Week" , "Export History Save Option" : l_Archieve});
          break;
          case "-1W" : 
          setAmplitudeEvent("Create Data Export Report",{" Standard Time Period": "Last Week" , "Export History Save Option" : l_Archieve});
          break;
          case "1M" :
          setAmplitudeEvent("Create Data Export Report",{" Standard Time Period": "This Month" , "Export History Save Option" : l_Archieve});
          break;
          case "-1M" : 
          setAmplitudeEvent("Create Data Export Report",{" Standard Time Period": "Last Month" , "Export History Save Option" : l_Archieve});
          break;
          case "1Y" : 
          setAmplitudeEvent("Create Data Export Report",{" Standard Time Period": "This Year" , "Export History Save Option" : l_Archieve});
          break;
          case "-1Y" :
          setAmplitudeEvent("Create Data Export Report",{" Standard Time Period": "Last Year" , "Export History Save Option" : l_Archieve});
          break;
          case "0D" :
          setAmplitudeEvent("Create Data Export Report",{" Standard Time Period": "Today" , "Export History Save Option" : l_Archieve});
          break;
          case "C" :    
          setAmplitudeEvent("Create Data Export Report",{"Custom Time Period" : "Custom Time Period radio dial button is selected" , "Export History Save Option" : l_Archieve});
          break;
          default:break;

      }


     

     
        const l_Request = this.props.saveExportWithoutSchedule(dataExportFinalData);
        l_Request.then((result) => {

          // Amplitude - Report Schedule 
          if (this.props.RecurrenceDetails.AmplitudeRecurrenceList !== undefined && this.props.RecurrenceDetails.AmplitudeRecurrenceList !== null && this.props.RecurrenceDetails.AmplitudeRecurrenceList.length > 0) {
            var index = 0;
            for (index = 0; index < this.props.RecurrenceDetails.AmplitudeRecurrenceList.length; index++) {

              setAmplitudeEvent("Report Schedule", {
                "Report Type": "Data Export", "User Flow": l_Actions, "Schedule Recurrence": this.props.RecurrenceDetails.AmplitudeRecurrenceList[index].intervalType, "File Format": this.props.RecurrenceDetails.AmplitudeRecurrenceList[index].exportFormat,
                "Report History Save Option": l_Archieve
              });
            }

          }

          this.setState({ redirectToListPage: true });
        });
      }
    } 
    else {
      // From Actions drop down
      //this will be our final generated data that 
      //will be sent over to saveReportSchedule api request 
      var scheduleFinalData = {
        "ReportScheduleParams" : this.props.RecurrenceDetails.ExportRecurrenceList,
        "CalendarEntry" : this.props.RecurrenceDetails.calendarEntries,
        "DeletionEntry" : this.props.RecurrenceDetails.deletedReportScheduleId,
        "RecipientEmail": this.state.emailReceipentDetails,
        "MaintainOnServer": this.state.IsNoArchive ? 0 : 1,
      };
     

      if(this.props.userHasFullaccess !== undefined && this.props.userHasFullaccess !== null){        
        if(this.props.userHasFullaccess === true){
          const l_Request = this.props.saveReportSchedule(scheduleFinalData); 
          l_Request.then((result) => {
            //Amplitude - Report Schedule 
            if (this.props.RecurrenceDetails.AmplitudeRecurrenceList !== undefined && this.props.RecurrenceDetails.AmplitudeRecurrenceList !== null && this.props.RecurrenceDetails.AmplitudeRecurrenceList.length > 0) {
              var index = 0
              for (index = 0; index < this.props.RecurrenceDetails.AmplitudeRecurrenceList.length; index++) {
                setAmplitudeEvent("Report Schedule", {
                  "Report Type": reportType, "User Flow": "Actions drop-down", "Schedule Recurrence": this.props.RecurrenceDetails.AmplitudeRecurrenceList[index].intervalType, "File Format": this.props.RecurrenceDetails.AmplitudeRecurrenceList[index].exportFormat,
                  "Report History Save Option": l_Archieve
                });
              }
            }
            this.setState({ redirectToListPage: true });
          }); 
        }else{
          this.setState({ redirectToListPage: true });     
        }             
      }
    }
  
  }

  handleRadio() {
    if (this.refs.NoArchive.checked) {
      this.setState({ IsNoArchive: true, IsArchive: false });
    } else {
      this.setState({ IsNoArchive: false, IsArchive:true });
    }
  }

  render() {
    if (this.state.redirectToListPage) {
      return <Redirect to="/ManageReports/ManageReportsDefinitions" />;
    }

    let hasFullaccess = this.props.userHasFullaccess;
    hasFullaccess = hasFullaccess !== undefined && hasFullaccess !== null && hasFullaccess ? true: false;

    return (
      <div id="Archive">
        {/*Header Section*/}
        <FormGroup row>
          <Col sm={{ size: 12 }}>
            <Label className="dataexportmainheaderlbl">
              {this.state.IsFromReportSchedules
                ? "Report Schedule for " + this.state.reportNameValue
                : "Data Export"}
            </Label>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={{ size: 12 }}>
            <Label className="dataexportheaderlbl">
              Report History Options
            </Label>
          </Col>
        </FormGroup>
        <hr />
        <FormGroup row>
          <Col sm={{ size: 12 }}>
            <input
              type="radio"
              disabled={this.state.isEmailOnlyRadioActive}
              ref="NoArchive"
              name="Archiveradio"
              value="0"
              checked={this.state.IsNoArchive}
              key="0"
              onChange={this.handleRadio}
            />
            {"     "}
            <Label
              className="archive_lbl"
              style={{
                marginRight: "4.5%",
                marginLeft: "1%",
                marginBottom: "0px",
                fontWeight:'bold',
                color:(this.state.isEmailOnlyRadioActive ? "#BBBBBB":"#000000")
              }}
            >
              Email report only 
            </Label>
            <br />
            <label
              style={{ "padding-left": "26.5px", "font-weight": "normal" , "color":(this.state.isEmailOnlyRadioActive ? "#BBBBBB":"#000000")
            }}
              className="workorderlbl"
            >
              Tracer Ensemble will send an email to the recipients you specify, but will not save a copy of the report to Report History.           
            </label>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={{ size: 12 }}>
            <input
              type="radio"
              disabled={this.state.isEmailRadioActive}
              ref="Archive"
              name="Archiveradio"
              value="1"
              checked={this.state.IsArchive}
              key="1"
              onChange={this.handleRadio}
            />
            {"     "}
            <Label
              className="archive_lbl"
              style={{
                marginRight: "4.5%",
                marginLeft: "1%",
                marginBottom: "0px",
                fontWeight:'bold'
              }}
            >
            Email report and save report history
            </Label>
            <br />
            <label
              style={{ "padding-left": "26.5px", "font-weight": "normal" }}
              className="workorderlbl"
            >
              Tracer Ensemble will send an email to the recipients you specify and save a copy of the report to Report History.
            </label>
          </Col>
        </FormGroup>
        {/*Button*/}
        <FormGroup row className="report_buttons">
          <Col sm={{ size: 12 }}>
            <hr />
            <Label
              style={{ position: "absolute", marginBottom: "0px", bottom: "0" }}
              className="link-cursor-underline"
              onClick={this.OnCancel}
            >
              Cancel
            </Label>
            <Button
              style={{ float: "right", marginRight: "0px" }}
              className="btn-success btn-md"
              onClick={() => {
                this.OnFinish();
              }}
            >
              {this.state.IsFromReportSchedules && !hasFullaccess ? "Close" : "Finish"}
            </Button>
            <Button
              style={{ float: "right", marginLeft: "0px" }}
              className="btn-gray btn-md"
              onClick={() => {
                this.goBack("4");
              }}
            >
              Back
            </Button>
          </Col>
        </FormGroup>
      </div>
    );
  }

}

const mapStateToProps = state => {
  return {
      userHasFullaccess: state.authService.HasApplicationFullAcess,
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    saveExportWithoutSchedule: (data) =>
      dispatch(saveExportWithoutSchedule(data)),
    updateExportWithoutSchedule: (data) =>
      dispatch(updateExportWithoutSchedule(data)),
    saveReportSchedule: (data) => dispatch(saveReportSchedule(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Archive);
